import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 斯洛文尼亚
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Vse pravice pridržane',
    },
    auth: {
        login: 'Prijava',
        username: 'Uporabniško ime',
        username_placeholder: 'Vnesite uporabniško ime',
        password: 'Geslo',
        password_placeholder: 'Vnesite geslo',
        code: 'Koda za preverjanje',
        code_placeholder: 'Vnesite kodo za preverjanje',
        logout: 'Odjava',
        logout_success: 'Uspešno ste se odjavili',
        day: 'dan',
        password_expiration: 'Veljavnost gesla je potekla – prosimo, da ga spremenite',
        expire: 'Preostali čas do poteka gesla',
        conseils:
            'Mora vsebovati velike črke, male črke, številke in posebne znake ({msg}). Dolžina gesla mora biti med 8 in 16 znaki.',
        brand_Selection: 'Izbor blagovne znamke',
        unread_notices: 'Neprebrana obvestila',
        new_cases: 'Nova vprašanja',
        unanswered_cases: 'Nerešena vprašanja',
        overdue_cases: 'Zapoznela vprašanja',
    },
    button: {
        query: 'Poizvedba',
        editing_position: 'Uredi položaj',
        show_theme_editor: 'Prikaži/skrij urejevalnik teme',
        change_password: 'Spremeni geslo',
        old_password: 'Staro geslo',
        new_password: 'Novo geslo',
        confirm_password: 'Potrdite geslo',
        button: 'Gumb',
        about: 'O nas',
        back: 'Nazaj',
        go: 'V redu',
        home: 'Domov',
        confirm: 'Potrdi',
        modify: 'Spremeni',
        edit: 'Uredi',
        new: 'Novo',
        cancel: 'Prekliči',
        close: 'Zapri',
        search: 'Išči',
        reset: 'Ponastavi',
        delete: 'Izbriši',
        add: 'Dodaj',
        collapse: 'Strni',
        expand: 'Razširi',
        download_template: 'Prenesi predlogo',
        batch_import: 'Uvozi v paketu',
        import: 'Uvozi',
        export: 'Izvozi',
        export_fail: 'Uvoz ni uspel',
        detailed: 'Podrobno',
        details: 'Podrobnosti',
        download: 'Prenesi',
        toView: 'Poglej',
        toViews: 'Poglej slike',
        uploadAttachments: 'Naloži priponke',
        selectFile: 'Izberi datoteko',
        fillingInstructions: 'Navodila za izpolnjevanje',
        release: 'Objavi',
        release_recall: 'Umakni objavo',
        save: 'Shrani',
        send: 'Pošlji',
        tips: 'Nasveti',
        send_back: 'Vrni nazaj',
        examine: 'Preglej',
        void: 'Razveljavi',
        more: 'Več',
        refresh: 'Osveži',
        selects: 'Izberi',
        serial_number: 'Serijska številka',
        upload_progress: 'Napredek nalaganja',
        invalid: 'Neveljavno',
        daily_record: 'Dnevni zapis',
        operation_type: 'Vrsta operacije',
        field_name: 'Ime polja',
        edit_role: 'Uredi vlogo',
        user_role: 'Izberite vlogo',
        assignment_role: 'Vloga',
        post: 'Delovno mesto',
        sending: 'Pošiljanje...',
        reset_password: 'Ponastavi geslo',
        display_or_not: 'Prikazati ali ne',
        document: 'Dokument',
        specificTemplates: 'Posebne predloge',
        transferOrder: 'Prenos naročila',
        forwarding: 'Posreduj',
        one_click_notification: 'Obvestilo z enim klikom',
        english_export: 'Izvoz v angleščini',
        oneclick_download: 'Prenos z enim klikom',
        passwordmsga:
            'Mora vsebovati velike črke, male črke, številke in posebne znake (@\\$!_~\\&*)',
        passwordmsgb: 'Dolžina gesla mora biti med 8 in 16 znaki',
        passwordmsgc: 'Ne sme biti enako kot katero koli od zadnjih šestih gesel',
        export_file_list: 'Seznam izvoženih datotek',
        personal_center: 'Osebni center',
        upload_list: 'Seznam naloženih',
        clear_completed: 'Počisti dokončano',
    },
    radio: {
        enabled: 'Omogočeno',
        disabled: 'Onemogočeno',
        catalogue: 'Katalog',
        individual: 'Posamezno',
        all: 'Vse',
        yes: 'Da',
        no: 'Ne',
    },
    dropdown: {
        close_others: 'Zapri ostale',
        close_right: 'Zapri desne',
        close_left: 'Zapri leve',
    },
    table: {
        action: 'Dejanje',
        explain: 'Pojasnilo',
        fileName: 'Ime datoteke',
        size: 'Velikost (MB)',
        uploader: 'Naložil(a)',
        uploadTime: 'Datum nalaganja',
        system: 'Sistem',
        caption: 'Naslov',
        categorization: 'Kategorizacija',
        link: 'Povezava',
        forwarding_time: 'Datum posredovanja',
        forwarder: 'Posredoval(a)',
        send_to: 'Pošlji komu',
        mode: 'Način',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `Stran ${named('number')}`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Skupaj ${named('number')} zapisov`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) => `Skupaj ${named('number')} vozil`,
    },
    confirm: {
        confirm_deletion: 'Potrdite brisanje?',
        confirm_void: 'Potrdite razveljavitev?',
        confirm_release: 'Potrdite objavo?',
        ack: 'Potrdi',
        cancel: 'Prekliči',
        non_records: 'Izberite vsaj en zapis',
    },
    request: {
        failed_placeholder: 'Zahteva ni uspela – napaka strežnika',
        success_placeholder: 'Zahteva je bila uspešna',
        auth: {
            login_success: 'Uspešna prijava',
        },
        error: {
            '404': 'Vir ni bil najden',
            '403': 'Nedovoljena dostopa',
        },
    },
    page: {
        global: {
            page_search: 'Iskanje na strani',
        },
        error: {
            not_found: 'Stran ni najdena',
            not_found_des: 'Nič tu ni',
            auth_failed: 'Nedovoljena dostopa',
            auth_failed_des: 'Ta stran je prepovedana',
            file_format_error: 'Neveljavna vrsta datoteke!',
            preview_failed: 'Predogled ni uspel! Datoteka je poškodovana!',
        },
        homepage: {
            homepage: homepage.homepage.slSI,
        },
        system: {
            menu: system.menu.slSI,
            dict: system.dict.slSI,
            dept: system.dept.slSI,
            role: system.role.slSI,
            user: system.user.slSI,
        },
        info: {
            announcement: Info.announcement.announcement.slSI,
            document: Info.document.document.slSI,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.slSI,
                recallActivity: tech.quality.recallActivity.slSI,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.slSI,
            },
            management: {
                inquiryOd: tech.management.inquiry.slSI,
                permission: tech.management.permission.slSI,
                onSiteSupportHq: tech.management.onSiteSupport.slSI,
                progHistoryHq: tech.management.progHistory.slSI,
                salesRecordHq: tech.management.salesRecord.slSI,
                vehicleInfoHq: tech.management.vehicleInfo.slSI,
                claimHq: tech.management.claim.slSI,
                filterHq: tech.management.filter.slSI,
                newCarlssue: tech.management.newCarIssue.slSI,
                newCarDefinition: tech.management.newCarDefinition.slSI,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.slSI,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.slSI,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.slSI,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.slSI,
        },
        statistics: statistics.inquiryStatistics.slSI,
        systemClassifyA: statistics.systemClassifyA.slSI,
        systemClassifyB: statistics.systemClassifyB.slSI,
        engineerStatistics: statistics.engineerStatistics.slSI,
        defectivePart: statistics.defectivePart.slSI,
        replyInquiryStatistics: statistics.replyInquiryStatistics.slSI,
        passRateStatistics: statistics.passRateStatistics.slSI,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.slSI,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.slSI,
        customsClearance135Rate: statistics.customsClearance135Rate.slSI,
        accumulatedClosureRate: statistics.accumulatedClosureRate.slSI,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.slSI,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.slSI,
    },
    validation: {
        common: {
            required: 'To polje je obvezno',
            numeric: 'Mora biti celo število',
            decimal: 'Mora biti število',
            positive_interger: 'Mora biti pozitivno celo število',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Največ ${named('number')} števk`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Dovoljenih je največ ${named('number')} znakov`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Presežena največja dolžina (${named('number')} znakov)`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Mora imeti vsaj ${named('number')} znakov`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Mora imeti točno ${named('number')} znakov`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ne sme biti večje od ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ne sme biti manjše od ${named('number')}`,
            up_to_2_decimal_places: 'Največ dve decimalni mesti',
            retain_up: 'Največ 10 števk pred decimalno vejico in 2 za njo',
            retain_ups: 'Največ 11 števk pred decimalno vejico in 4 za njo',
            input_number: 'Vnesite le arabske številke',
            only_number_a: 'Dovoljene so le črke ali številke',
            translate: 'Dovoljene so le črke',
            positive_integer: 'Izpolnite vsaj eno polje',
            at_least_one: 'Izpolnite vsaj eno',
        },
        tip: {
            incomplete_information: 'Podatki so nepopolni',
        },
    },
    import: {
        template_file: 'Datoteka predloge',
        browse: 'Brskaj',
        download_template: 'Prenesi predlogo',
        no_file_selected: 'Ni izbrane datoteke',
        incorrect_file_type: 'Napačna vrsta datoteke',
        exceed: 'Prekoračitev omejitve',
        upload_success: 'Nalaganje uspešno',
        upload_fail: 'Nalaganje ni uspelo',
        again_upload:
            'Naložiti je mogoče le slike v formatih jpg, png, bmp ali gif. Poskusite znova.',
        attachmentUpload: 'Naloži priponke',
        otherAttachmentUpload: 'Naloži druge priponke',
        supportedFormats: 'Podprti formati',
        preview: 'Predogled',
    },
    export: {
        noDataToExport: 'Ni podatkov za izvoz',
    },
    select: {
        all: 'Vse',
    },
    checkbox: {
        select_all: 'Izberi vse',
    },
    dialog: {
        error_message: 'Sporočilo o napaki',
        one_year: 'Hkrati lahko izvozite največ enoletne podatke',
    },
    ymd: {
        year: 'leto',
        month: 'mesec',
        day: 'dan',
        week: 'teden',
        january: 'Januar',
        february: 'Februar',
        march: 'Marec',
        april: 'April',
        may: 'Maj',
        june: 'Junij',
        july: 'Julij',
        august: 'Avgust',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'December',
    },
};
